import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { ApiWaveRequiredMetadata } from "@/generated/models/ApiWaveRequiredMetadata";
export default function CreateDropContentMissingMetadataWarning(t0) {
  const $ = _c(8);
  const {
    missingMetadata
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      STRING: "text",
      NUMBER: "number"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TYPE_LABELS = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-inline-flex tw-items-center tw-gap-x-2" data-tooltip-id="missing-metadata-warning"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#FEDF89]" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-xs tw-text-[#FEDF89]">Metadata is required</span></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== missingMetadata) {
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = (metadata, i) => <li key={`missing-metadata-tooltip-${i}`}>"{metadata.name}" is required (type:{" "}{TYPE_LABELS[metadata.type]})</li>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t4 = missingMetadata.map(t5);
    $[3] = missingMetadata;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <>{t2}<Tooltip id="missing-metadata-warning" style={t3}><ul>{t4}</ul></Tooltip></>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}